export default __webpack_public_path__ + "static/skulptur-stiftung-483fd0ff65aca02bfb08181a5adf34e3.jpg";